const protocolPart = 'json-ir://';
export const createPublicSchemaId = (parts) => {
    return `${protocolPart}public@${parts.clusterId}/${parts.schemaTag}`;
};
export const createTenantSchemaId = (parts) => {
    return `${protocolPart}${parts.tenantId}@${parts.clusterId}/${parts.schemaTag}`;
};
export const getSchemaTag = (schemaId) => {
    if (!schemaId)
        return '';
    const atIndex = schemaId.indexOf('@');
    if (atIndex === -1)
        return '';
    const afterVariant = schemaId.slice(atIndex + 1);
    const slashIndex = afterVariant.indexOf('/');
    if (slashIndex === -1)
        return '';
    const tagWithVersion = afterVariant.slice(slashIndex + 1);
    return tagWithVersion.split('?')[0];
};
//# sourceMappingURL=schemaId.js.map